import { useSubscription } from '@rta/rta-blueprint-library';

import { Controller } from '@context';
import { lang } from '@lang';
import { useDesign } from '@hooks';
import { Feature, FeatureHoookParams } from '..';

type CutoutFeatureParams = FeatureHoookParams;
export const useShowCutoutFeature = (_params: CutoutFeatureParams = {}): Feature<boolean> => {
	const [controller] = useDesign<Controller, { options: { showCutouts: boolean }}>();

	useSubscription(controller, false, [['layer-option-cutout', '*']]);

	const controllerSupportsFeature = (controller?.options?.showCutouts ?? null) !== null;
	const showLayer = controller?.options?.showCutouts ?? true;

	const tooltip = (() => {
		const showHide = showLayer ? lang.layer.tooltip.hide : lang.layer.tooltip.show;
		return `${showHide} ${lang.layer.label.cutouts} ${lang.layer.layer}`;
	})();

	return {
		name: 'showCutout',
		label: lang.layer.label.cutouts,
		shortcut: '',
		tooltip,
		icon: (props = {}) => <></>,
		disabled: !controllerSupportsFeature,
		value: showLayer,
		hidden: false,
		handler: () => {
			if (controller) {
				controller.options.showCutouts = !showLayer;
			}
		}
	};
};
